module.exports = __webpack_public_path__ + "static/img/h6-5.f35da1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-5.png
// module id = DAYQ
// module chunks = 1